import React, { FC } from "react";

import { FieldAttributes, useField } from "formik";
import { TextField } from "@material-ui/core";

export const LoginTextField: FC<FieldAttributes<any>> = ({
  label,
  id,
  type,
  ...props
}) => {
  const [field, meta] = useField<any>(props);
  const errorText = meta.error && meta.touched ? meta.error : "";
  return (
    <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      label={label}
      id={id}
      type={type}
      {...field}
      helperText={errorText}
      error={!!errorText}
    />
  );
};
